/* eslint-disable no-console */
import React from 'react';
import TWHeader from './Components/TWHeader';
import TWDescription from './Components/TWDescription';
import TWUserDetails from './Components/TWUserDetails';
import PanellistDetails from './Components/PanellistDetails';

const LeftTrainingLogin = (props) =>
{
	const { joinDetails } = props;

	return (
		<div className='flexCol alignCntr padding80 fullHeight'>
			{Object?.keys(joinDetails)?.length > 0 &&
			<>
				<TWHeader joinDetails={joinDetails} />
				<TWDescription joinDetails={joinDetails} />

				{/* <MeetingCountdown/> */}
				{/* <SpeakerDetails/> */}
				<TWUserDetails joinDetails={joinDetails}/>
				{joinDetails?.panalListData && joinDetails?.panalListData?.length > 0 &&
				<PanellistDetails joinDetails={joinDetails}/>}
			</>
			}
		</div>
	);
};

export default LeftTrainingLogin;